import AssetTypes from './AssetTypes';

export default AssetTypes;
